import { JustAddressReponse } from '@business/entities/organization';

export function getZillowLink(address: Partial<JustAddressReponse>): string | null {
  if (!address?.address) return null;

  const parts = [address.address, address.city, address.state, address.postal].filter(Boolean);
  const encoded = encodeURIComponent(parts.join(', '));
  return `https://www.zillow.com/homes/${encoded}_rb/`;
}
